@if (!progressBar) {
<div class="row" id="loader">
  <div class="col-12 text-center">
    <div class="spinner-border text-dark"></div>
    <p class="text-dark mt-2">Bezig met laden</p>
  </div>
</div>
} @if (progressBar) {
<div class="w-100">
  <div class="progress">
    <div
      class="progress-bar"
      role="progressbar"
      [ngStyle]="{ 'width.%': progressPercentage }"
    ></div>
  </div>
</div>
}
